<template>
  <div>
    <BCard  class="mb-2">
      <BCardTitle>Series</BCardTitle>
      <div class="">
        <BForm>
            <BRow class="align-items-center">
            
            <VSelectValidated vsMd="5" vsName="Serie" :vsModel.sync="groupSerie.serie_id" :vsReduce="serie => serie.id" :vsOptions="seriesOptions" vsLabel="search_name" vsRequired vsRules="required"/>
              <BCol cols="2" >
                <BButton vsMd="4" variant="primary" @click="createGroupSerie">Añadir</BButton>
              </BCol>
            <!-- <CheckboxValidated vsName="default_serie" vsLabel="Por defecto" :vsModel.sync="groupSerie.is_default"></CheckboxValidated> -->
          </BRow>
        </BForm>
        <hr>
        <BRow>
          <BCol cols="12" v-for="(serie, index) in group.series" :key="serie.id" class=" mt-1 align-items-baseline">
            <div v-if="index!=0 && group.series[index-1].billing_document_id!=serie.billing_document_id" style="border-top: 0.8px solid #a2a6ad" class="w-100 col col-12 mb-3"></div>

            <!-- <p>{{ group.series[index].billing_document_id}} {{ serie.billing_document_id  }}</p> -->
            <BRow>
              <p class="mr-2 col col-3" style="text-transform: uppercase;"> {{ serie.billing_document.name }}</p>
              <p class="mr-2 col col-2"><b>{{ serie.name }}</b></p>
              <p class="mr-2 col col-1" >{{ serie.identifier }}</p>
              <p class="mr-2 col col-1">{{ serie.sequence }}</p>
              <!-- <ViewData vsIcon="" :vsValue="" vsCheckbox /> -->
              <div class="col col-1 ">
                <BButton  variant="flat-danger" class="btn-icon p-0" @click="deletePopupAxios(serie.id, `group-serie/${serie.pivot.id}`)">
                  <FeatherIcon size="18" icon="TrashIcon" />
                </BButton>
              </div>
              <BButton v-if="serie.pivot.is_default" variant="outline-primary" disabled>Predeterminada</BButton>
              <BButton v-else variant="primary" @click="setDefaultSerie(serie)">Marcar por defecto</BButton>
            </BRow>
          </BCol>
        </BRow>
      </div>
    </BCard>

    <BCard  class="mb-2">
      <BCardTitle>Cuentas bancarias</BCardTitle>
      <div>
        <BForm>
            <BRow class="align-items-center">
            <VSelectValidated vsMd="5" vsName="Cuenta bancaria" :vsModel.sync="groupBankAccount.bank_account_id" :vsReduce="bank => bank.id" :vsOptions="bankAccountsOptions" vsLabel="search_name" vsRequired vsRules="required"/>
              <BCol cols="2" >
                <BButton vsMd="4" variant="primary" @click="createGroupBankAccount">Añadir</BButton>
              </BCol>

            <!-- <CheckboxValidated vsName="default_bank" vsLabel="Por defecto" :vsModel.sync="groupBankAccount.is_default"></CheckboxValidated> -->
          </BRow>
        </BForm>
        <hr>
        <BRow >
          
          <BCol cols="12" v-for="bank in group.bank_accounts" :key="bank.id" class="mt-1 d-flex align-items-baseline">
            <p class="mr-2 col col-3"><b>{{ bank.name }}</b></p>
            <p class="mr-2 col col-3">{{ bank.iban }}</p>
            <!-- <ViewData :vsValue="bank.pivot.is_default" vsCheckbox /> -->
            <div class="col col-1 ">
              <BButton  variant="flat-danger" class="btn-icon p-0" @click="deletePopupAxios(bank.id, `group-bank-account/${bank.pivot.id}`)">
                <FeatherIcon size="18" icon="TrashIcon" />
              </BButton>
            </div>
            <BButton v-if="bank.pivot.is_default" variant="outline-primary" disabled>Predeterminada</BButton>
            <BButton v-else variant="primary" @click="setDefaultBankAccount(bank)">Marcar por defecto</BButton>

          </BCol>

        </BRow>
      </div>
    </BCard>

    </div>
  </template>
  
  <script>
  import { BCard, BButton, BAvatar, BRow, BCol, BFormCheckbox, BCardTitle, BForm, BFormRadio, BFormRadioGroup} from 'bootstrap-vue'
  import { inject, provide, ref } from '@vue/composition-api';
  import ViewData from '@/components/ViewData.vue';
  import SeriesAddEdit from '../../series/SeriesAddEdit.vue';
  import { getSeries } from '@/composables/serieService';
  import { getBankAccounts } from '@/composables/bankAccountService';
  import SeriesList from '../../series/SeriesList.vue'
  import VSelectValidated from '@/components/forms/vSelectValidated.vue'
  import CheckboxValidated from '@/components/forms/CheckboxValidated.vue'
  import { addGroupSerie, addGroupBankAccount, addDefaultBankAccount, addDefaultSerie } from '@/composables/groupService'
  import popups from '@/hooks/popups'

  export default {
    components: { BCard, BButton, BRow, BCol, BAvatar, BFormCheckbox, ViewData, SeriesList, SeriesAddEdit, BCard, BCardTitle, VSelectValidated, CheckboxValidated, BForm, BFormRadio, BFormRadioGroup },
    emits: ['refetch-data'],
    setup(props, {emit}) {
      const group = inject('group')
      const addModal = ref(null)
      const seriesModal = ref(null)
      const bankAccountsOptions = ref([])
      const seriesOptions = ref([])
      const groupSerie = ref({
        serie_id: null,
        is_default: null,
        group_id: group.value.id
      })

      const defaultSerie = ref(null)

      const { errorToast, successToast, deletePopupAxios } = popups()

      const groupBankAccount = ref({
        bank_account_id: null,
        is_default: null,
        group_id: group.value.id
      })

      const fetchData = () => {
        emit('refetch-data')
      }

      const series = ref('')
      provide('addModal', addModal)
      provide('seriesModal', seriesModal)
      provide('series', series)

      const showAddModal = () => {
        addModal.value=true
        seriesModal.value.show()
      }

      const fetchSeries = async function () {
        let response = await getSeries()
        seriesOptions.value = response.data.series
      }
      const fetchBankAccounts = async function () {
        let response = await getBankAccounts()
        bankAccountsOptions.value = response.data.bank_accounts
      }

      const createGroupSerie = async function () {
        if (!groupSerie.value.serie_id) {errorToast('Introduce una serie'); return}
        
        let response = await addGroupSerie(groupSerie.value)
        if (response.data.success) {
          successToast("Serie añadida correctamente")
          groupSerie.value = ({
            serie_id: null,
            is_default: null,
            group_id: group.value.id
          })
          emit('refetch-data')
        } else {
          if (response.data.code=="ALREADY_EXISTS") {
            errorToast("Esta serie ya está asociada a la sucursal")
          } else {
            errorToast("Error añadiendo serie")
          }
        }
      }

      const setDefaultSerie = async function (serie) {
        let data = {
          group_id: group.value.id,
          group_serie_id: serie.pivot.id,
          billing_document_id: serie.billing_document_id
        }

        let response = await addDefaultSerie(data)
        fetchData()
      }

      const setDefaultBankAccount = async function (bank_account) {
        let data = {
          group_id: group.value.id,
          group_bank_account_id: bank_account.pivot.id,
        }

        let response = await addDefaultBankAccount(data)
        fetchData()
      }


      const createGroupBankAccount = async function () {
        if (!groupBankAccount.value.bank_account_id) { errorToast("Introduce una cuenta bancaria"); return }


        let response = await addGroupBankAccount(groupBankAccount.value)
        if (response.data.success) {
          successToast("Cuenta bancaria añadida correctamente")
          groupBankAccount.value = ({
            bank_account_id: null,
            is_default: null,
            group_id: group.value.id
          })
          emit('refetch-data')
        } else {

          if (response.data.code=="ALREADY_EXISTS") {
            errorToast("Esta cuenta bancaria ya está asociada a la sucursal")
          } else {
            errorToast("Error añadiendo cuenta bancaria")
          }

        }
      }


      fetchSeries()
      fetchBankAccounts()


      return {
        group,
        showAddModal,
        bankAccountsOptions,
        seriesOptions,
        groupSerie,
        groupBankAccount,
        createGroupSerie,
        createGroupBankAccount,
        deletePopupAxios,
        fetchData,
        defaultSerie,
        setDefaultSerie,
        setDefaultBankAccount
      }
    },
  }
  </script>
  
  <style lang="scss">
  @import 'src/assets/scss/variables/_variables.scss';
  table tr th {
    color: $primary;
  }
  
  table tr th span {
    text-transform: uppercase;
  }
  </style>
  